module.exports = __webpack_public_path__ + "img/dy.1411a2fc.jpg";